import { create } from 'zustand';

interface LoaderStoreState {
  loading: boolean;
  message: string;
  showLoader: (msg?: string) => void;
  hideLoader: () => void;
}

export const useLoaderStore = create<LoaderStoreState>((set) => ({
  loading: false,
  message: '',
  showLoader: (msg = '') => set({ loading: true, message: msg }),
  hideLoader: () => set({ loading: false, message: '' }),
}));
